import { render, staticRenderFns } from "./ExpertDetail.vue?vue&type=template&id=7b6f3ba1&scoped=true&"
var script = {}
import style0 from "./ExpertDetail.vue?vue&type=style&index=0&id=7b6f3ba1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6f3ba1",
  null
  
)

export default component.exports